<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-08 09:43:37
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-08 19:24:47
 * @Description: 财务报告 2016
 -->
<template>
  <div class="financial-reports-2016">
    <img :src="item" alt="" srcset="" v-for="(item, index) in imgList" :key="index" />
  </div>
</template>
<script>
export default {
  name: 'financial-reports-2016',
  computed: {
    imgList() {
      let arr = [];
      for (let i = 1; i < 18; i++) {
        const index = i < 10 ? `0${i}` : i;
        arr.push(`https://files.jinr.com/jinr-index/financial-reports/2016/${index}.jpg`);
      }
      return arr;
    }
  }
};
</script>
